import React from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components/macro'
import {AttachmentBoxFooter} from "../AttachmentBoxStyles";
import {FormattedMessage} from "react-intl";

styled

export const RecordRowQuarantinedFooter = ({withMoveHandler = false}) =>
  <AttachmentBoxFooter alert withMoveHandler={withMoveHandler} inFlow>
    <div css="padding-left: 28px;"><FormattedMessage
      defaultMessage="Status"
      description="Uploader, record status label"
      />: <b><FormattedMessage
      defaultMessage="Quarantined"
      description="Uploader, record status, quarantined"
    /></b></div>
    <div><FormattedMessage
      defaultMessage="This medical record file has potentially harmful data."
      description="Uploader, record status, quarantined description"
    /></div>
  </AttachmentBoxFooter>